export enum Environment {
  DevelopmentLocal = "DEVELOPMENT_LOCAL",
  Development = "DEVELOPMENT",
  Staging = "STAGING",
  Production = "PRODUCTION",
}
